export class TypeTvaModel {
  public id = 0;
  public codeTva: string = null;
  public rate = 0;
  public label = '';
  public codeLabel: string;
  // public client = '';

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: TypeTvaModel[] = [];
    jsons.forEach(json => {
      refs.push(new TypeTvaModel().fromJSON(json));
    });
    return refs;
  }
}
